import React from 'react'

interface MetricTileProps {
  label: string
  value: string | number
  subtitle?: string
  icon: string
  iconColor?: string
  tooltip?: string
}

const MetricTile: React.FC<MetricTileProps> = ({
  label,
  value,
  subtitle,
  icon,
  iconColor = 'bg-light-primary',
  tooltip,
}) => {
  return (
    <div className='card h-100'>
      <div className='card-body p-6'>
        <div className='d-flex justify-content-between align-items-start mb-4'>
          <span className='fw-semibold text-gray-600 fs-7'>
            {label}
            {tooltip && (
              <i
                className='fas fa-info-circle text-muted fs-8 ms-1'
                title={tooltip}
                style={{cursor: 'default'}}
              />
            )}
          </span>
          <div
            className={`rounded-2 p-2 d-flex align-items-center justify-content-center ${iconColor}`}
            style={{width: 40, height: 40}}
          >
            <i className={`${icon} fs-4`} />
          </div>
        </div>
        <div className='fs-2hx fw-bold text-dark mb-1'>{value}</div>
        {subtitle && <div className='text-muted fs-7 mt-1'>{subtitle}</div>}
      </div>
    </div>
  )
}

export default MetricTile
